<template>
   <div>
       <div class="table-wrapper on-767" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="text-white font-weight-bold text-right"><span class="invisible">asdf</span></td>
                            <td class="text-white font-weight-bold text-right">31 December 2020</td>
                            <td class="text-white font-weight-bold text-right">31 December 2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-center text-white font-weight-bold text-right" colspan="2">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Collectively assessed</td>
                            <td class="text-right">191,200</td>
                            <td class="text-right">158,662</td>
                        </tr>
                        <tr>
                            <td>Individually assessed</td>
                            <td class="text-right">9,546</td>
                            <td class="text-right">10,739</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-white font-weight-bold text-right">200,746</td>
                            <td class="text-white font-weight-bold text-right">169,401</td>
                        </tr>
                    </tbody>
                </table>
            </div>
       </div>

       <!-- Arabic -->

       <div class="table-wrapper on-767" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="text-white font-weight-bold text-right"><span class="invisible">asdf</span></td>
                            <td class="text-white font-weight-bold text-right">31 ديسمبر 2020</td>
                            <td class="text-white font-weight-bold text-right">31 ديسمبر 2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-center text-white font-weight-bold text-right" colspan="2">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>على أساس جماعي</td>
                            <td class="text-right">191,200</td>
                            <td class="text-right">158,662</td>
                        </tr>
                        <tr>
                            <td>على أساس فردي</td>
                            <td class="text-right">9,546</td>
                            <td class="text-right">10,739</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-white font-weight-bold text-right">200,746</td>
                            <td class="text-white font-weight-bold text-right">169,401</td>
                        </tr>
                    </tbody>
                </table>
            </div>
       </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>